
import React from 'react';
import style from './style.module.scss';
import {IProps, IHandlers} from './types';
import {Button} from '@material-ui/core';
import classNames from "classnames";
import {renderIf} from "app/services/reactUtils.service";
import moment from "moment";

const NS = 'SeatTimeButton';

export default function SeatTimeButton({isDisabled, selectedTime, handleSeatNow}: IProps & IHandlers) {
  return (
    <Button
      className={classNames({
        [style.btn]: true,
        [style.btnIsDisabled]: isDisabled
      })}
      variant="outlined" color="default" size="medium"
      disabled={isDisabled}
      onClick={handleSeatNow}>
      Seat {renderIf(selectedTime, () => (
      <>
        for {moment(selectedTime).format('hh:mma')}
      </>
    ))}
    </Button>
  )
}

